import React, { useMemo } from "react";
import { FiShoppingCart } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";

import logo from "../../assets/images/logo.png";

const Navbar = () => {
  const { items } = useCart();

  const totalItems = useMemo(() => {
    return items.reduce((sum, item) => sum + (item.quantity || 1), 0);
  }, [items]);

  return (
    <nav className="sticky top-0 z-40 w-full border-b border-[#a6a6a6]/30 bg-[#000000]/95 shadow-lg shadow-black/20 backdrop-blur-sm">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 sm:py-5">
        <Link to="/" className="flex items-center">
          <img src={logo} alt="Logo" className="h-12 w-auto sm:h-14" />
        </Link>

        <Link
          to="/yourorder"
          className="relative flex items-center gap-2 rounded-xl border-2 border-[#e0d8c3] bg-transparent px-4 py-2.5 text-[#e0d8c3] font-semibold transition hover:bg-[#e0d8c3] hover:text-[#000000] active:scale-[0.98]"
        >
          <FiShoppingCart size={20} className="sm:h-[22px] sm:w-[22px]" />
          <span className="hidden sm:inline">Shporta</span>
          {totalItems > 0 && (
            <span className="absolute -top-1.5 -right-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-[#e0d8c3] text-xs font-bold text-[#000000]">
              {totalItems}
            </span>
          )}
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
